/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:24:05
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageBrain.js
 * @Description: 工业大脑
 */

import React from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import './pageBrain.less';

const structureData = [
    {
        imgSrc: require('../../asset/image/pageBrain/yewu-cj1.png'),
        title: '企业知识库',
        text: '汇集行业知识、企业管理规范和经验等，基于知识图谱构建企业知识库，解决数据多源异构造成知识协同困难的问题，有效提升员工获取知识的效率',
    },
    {
        imgSrc: require('../../asset/image/pageBrain/yewu-cj2.png'),
        imgWidth: '3.14rem',
        title: '辅助设备检修',
        text: '在企业知识库中加入设备维修手册、培训文档和使用说明等文档和视频材料，构建设备检修智能问答，帮助维修工程师和用户高效定位问题，获得指导',
    },
    {
        imgSrc: require('../../asset/image/pageBrain/yewu-cj3.png'),
        title: '故障预测',
        text: '基于设备运行参数和历史故障数据构建系统运行知识图谱应用， 并对联网设备实施全局监控，实时发现状态异常的节点，通过人工干预降低故障发生的概率',
    },
    {
        imgSrc: require('../../asset/image/pageBrain/yewu-cj4.png'),
        title: '供应链预测',
        text: '基于需求、生产、供应和市场数据的提取和深度挖掘，帮企业更好地管理供需关系，提升生产效率，降低运营风险',
    }
];

const proinfoData = [
    {
        imgSrc: require('../../asset/image/pageBrain/icon_jishuzhicheng.svg'),
        title: '强大的技术支撑',
        text: '基于需求、生产、供应和市场数据的提取和深度挖掘，帮企业更好地管理供需关系，提升生产效率，降低运营风险'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_yewuzhuanjia.svg'),
        title: '业务专家团队',
        text: '兼具丰富的的行业知识和产品知识，可协同客户根据实际需求进行业务建模和定制化方案设计'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_fengfu.svg'),
        title: '丰富的系统建设经验',
        text: '多年的企业级系统建设，在各种业务规模的系统上都有多次成功实践'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_zhuanye.svg'),
        title: '专业的交付团队',
        text: '在海量客服交付案例中提炼出行之有效的标准化的交付流程，并锻炼了一⽀客户导向的专业交付团队'
    }
];

const PageBrain = props => {
    const bannerInfo = props.bannerInfo || {};
    return (
        <div className={'product Brain'}>
            <div className="pro-banner-box bg-new">
                <ProBanner
                    title={bannerInfo.title}
                    urlText={bannerInfo.urlText}
                    bgImg={bannerInfo.bgImg}
                    url={bannerInfo.url}
                />
                {bannerInfo.nextText ? (
                    <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                        {bannerInfo.nextText}
                    </a>
                ) : null}
            </div>

            <div className={'product-des'}>
                {bannerInfo.bannerNote}
            </div>

            <div className={'product-mod'}>
                <ProductTitle title={'业务结构'} />
            </div>
            <div>
                <img src={require('../../asset/image/pageBrain/yewu-jiegou1.png')} alt="" width={'100%'} />
                <img src={require('../../asset/image/pageBrain/yewu-jiegou2.png')} alt="" width={'100%'} />
            </div>
            <div className={'product-mod mt100'}>
                <ProductTitle title={'业务场景'} />
            </div>
            <div>
                {
                    structureData.map(({imgSrc, title, text, imgWidth}, index) => {
                        return <div className={(index + 1) % 2 === 0 ? 'structure hui' : 'structure'} key={index}>
                            <div
                                className={'shadow'}
                            >
                                <div className={'imgBor'} style={{width: imgWidth ? imgWidth : '100%'}}>
                                    <img
                                        src={imgSrc}
                                        alt={title}
                                    />
                                </div>
                            </div>
                            <div className={'title'}>
                                {title}
                            </div>
                            <div className={'text'}>
                                {text}
                            </div>
                        </div>;
                    })
                }
            </div>

            <div className={'product-mod mt100'}>
                <ProductTitle title={'方案优势'} />
            </div>

            <div className={'product-mod sec-p-box'}>
                {
                    proinfoData.map(({imgSrc, title, text}, index) => {
                        return <div className={'proinfo-box mui-flex'} key={index}>
                            <div className={'proinfo-box-icon'}>
                                <img
                                    src={imgSrc}
                                    width={'100%'}
                                />
                            </div>
                            <div className={'cell'}>
                                <div className={'proinfo-box-title'}>{title}</div>
                                <div className={'proinfo-box-des'}>
                                    {text}
                                </div>
                            </div>
                        </div>;
                    })
                }
            </div>

            <div style={{background: '#F5F5F5', paddingBottom: '1rem'}}>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="相关产品" />
                </div>
                <div>
                    {
                        [
                            {
                                title: '安全知识图谱',
                                content: '应用知识图谱技术实现知识抽取和业务建模等应用，支持百亿以上的实体和关系管理，基于业'
                                    + '务场景对数据进行深度关联分析，可广泛应用于公安侦查、金融风控、营销管理和企业综合应用等场景',
                                url: 'https://anquan.baidu.com/product/skg'
                            },
                            {
                                title: '图数据库',
                                content: 'HugeGraph是一款易用、高效、通用的图数据库，实现了Apache TinkerPop3'
                                    + '框架及兼容Gremlin查询语言。支持百亿以上的顶点(Vertex)和边(Edge)快速导入，'
                                    + '并提供毫秒级的关联查询能力，并可与Hadoop、Spark等大数据平台集成以进行离线分析。'
                                    + '主要应用场景包括关联分析、欺诈检测和知识图谱等。',
                                url: 'https://anquan.baidu.com/page/27'
                            },
                            {
                                title: '数据安全与隐私解决方案',
                                content: '依托百度领先的数据安全能力及隐私保护技术，数据安全与隐私解决方案集成数据治理'
                                    + '与敏捷大数据分析、AI数据脱敏及联邦计算，覆盖数据资产管理、敏感数据处理及安全合规'
                                    + '数据流通三大场景，助力企业实现数据全生命周期的安全治理及防护。',
                                url: 'https://anquan.baidu.com/product/dpsec'
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-app-solution-card">
                                    <div className="title">{item.title}</div>
                                    <div className="content">{item.content}</div>
                                    <a href={item.url} target="_blank" className="btn">了解详情</a>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div className="saas-app-solution-contact">
                <div className="saas-app-solution-contact-inner">
                    <div className="des" style={{paddingTop: '1.2rem'}}>
                        联系我们立即获取免费技术专家咨询
                    </div>
                    <a href={bannerInfo.url} className="btn" style={{marginTop: '.76rem'}}>
                        立即咨询
                    </a>
                </div>
            </div>
        </div>
    );

};

PageBrain.propTypes = {
    bannerInfo: PropTypes.object
};

export default PageBrain;



// WEBPACK FOOTER //
// ./src/containers/product/pageBrain.js